import { render, staticRenderFns } from "./FormCounter.vue?vue&type=template&id=f19f640a"
import script from "./FormCounter.vue?vue&type=script&lang=ts"
export * from "./FormCounter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports